import React, {useContext, useState, useRef, useEffect} from "react";
import {showcaseProjects} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import {Fade} from "react-reveal";
import "./ShowcaseProjects.scss";

export default function ShowcaseProjects() {
  const {isDark} = useContext(StyleContext);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Refs for all videos
  const videoRefs = useRef([]);

  // Play video when hoveredIndex changes
  useEffect(() => {
    if (hoveredIndex !== null && videoRefs.current[hoveredIndex]) {
      const video = videoRefs.current[hoveredIndex];
      video.currentTime = 0;
      video.play().catch(err => {
        // Handles autoplay restrictions
        console.log("Video play prevented:", err);
      });
    }
  }, [hoveredIndex]);

  if (!showcaseProjects.display) return null;

  return (
    <Fade bottom duration={1000} distance="20px">
      <div
        className={isDark ? "dark-mode main" : "main"}
        id="showcase-projects"
      >
        <div className="showcase-header">
          <h1 className="showcase-title">{showcaseProjects.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode showcase-subtitle"
                : "subTitle showcase-subtitle"
            }
          >
            {showcaseProjects.subtitle}
          </p>
        </div>

        <div className="showcase-cards-div">
          {showcaseProjects.projects.map((project, i) => (
            <div
              className={isDark ? "showcase-card-dark" : "showcase-card"}
              key={i}
              onMouseEnter={() => setHoveredIndex(i)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="showcase-card-image-wrapper">
                {/* Base image */}
                <img
                  src={project.image}
                  alt={project.title}
                  className="showcase-card-image base-image"
                />

                {/* Video (fade-in on hover) */}
                {project.video && (
                  <video
                    ref={el => (videoRefs.current[i] = el)}
                    src={project.video}
                    className={`showcase-card-image video-preview ${
                      hoveredIndex === i ? "fade-in" : ""
                    }`}
                    loop
                    muted
                    playsInline
                  />
                )}
              </div>

              <div className="showcase-card-content">
                <h2 className="showcase-card-title">{project.title}</h2>
                <p className="showcase-card-desc">{project.description}</p>
                <div className="showcase-card-footer">
                  {project.link && (
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="showcase-card-button"
                    >
                      Visit
                    </a>
                  )}
                  {project.download && (
                    <a
                      href={project.download}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="showcase-card-button"
                    >
                      Download
                    </a>
                  )}
                  {project.source && (
                    <a
                      href={project.source}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="showcase-card-button"
                    >
                      Source
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Fade>
  );
}
